export const Api_url = 'https://api.myonlineuniversity.com';
// export const Api_url = 'http://localhost:1336';
export const time_out = 1500;
export const PUBLIC_URL = '';
